import { render, staticRenderFns } from "./topicSettingDialog.vue?vue&type=template&id=2ad76178&scoped=true"
import script from "./topicSettingDialog.vue?vue&type=script&lang=js"
export * from "./topicSettingDialog.vue?vue&type=script&lang=js"
import style0 from "./topicSettingDialog.vue?vue&type=style&index=0&id=2ad76178&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad76178",
  null
  
)

export default component.exports